<template>
  <div id="app">
    <main-header></main-header>
    <div class="page mb-10">
      <router-view/>
    </div>
    <main-footer></main-footer>
    <v-slide-y-transition>
      <div v-if="showCookieBanner" class="cookie-banner">
        <div class="cookie-banner-content">
          <p>
            {{ $t('cookie_banner_text') }}
            <router-link class="cookie-policy-link" to="/privaatsuspoliitika">{{ $t('cookie_policy_link') }}</router-link>.
          </p>
          <div class="cookie-banner-actions">
            <v-btn color="eraklient" variant="flat" @click="acceptCookies">{{ $t('cookie_accept') }}</v-btn>
            <v-btn variant="outlined" @click="denyCookies">{{ $t('cookie_deny') }}</v-btn>
          </div>
        </div>
      </div>
    </v-slide-y-transition>
  </div>
</template>

<script>
import MainHeader from "@/components/MainHeader";
import MainFooter from "@/components/MainFooter";
import flagEstonia from '@/assets/images/flag-estonia.svg';
import { useHead } from '@vueuse/head'
import {computed, reactive} from "vue";
import {useI18n} from "vue-i18n";

export default {
  name: 'App',
  data() {
    return {
      showCookieBanner: false,
    };
  },
  computed: {},
  setup() {
    const { t } = useI18n()
    const siteData = reactive({
      title: computed(() => `Lõhnakas OÜ`),
      description: computed(() => `${t('home_desc')}`)
    })
    useHead({
      title: computed(() => siteData.title),
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
      ],
    })
  },
  components: {MainFooter, MainHeader},
  methods: {
    openCookieBanner() {
      this.showCookieBanner = true;
    },
    setCookieConsent(value) {
      localStorage.setItem('cookieConsent', value);
      window.__COOKIE_CONSENT__ = value;
      this.showCookieBanner = false;
    },
    acceptCookies() {
      this.setCookieConsent('accepted');
    },
    denyCookies() {
      this.setCookieConsent('denied');
    },
  },
  created() {
    const savedLocale = localStorage.getItem('locale');
    const savedLang = localStorage.getItem('selectedLang');
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (savedLocale) {
      this.$i18n.locale = savedLocale;
    }
    if (savedLang) {
      this.$i18n.selectedLang = savedLang;
    }
    else if (!savedLang) {
      this.$i18n.selectedLang = flagEstonia;
    }

    window.__COOKIE_CONSENT__ = cookieConsent;
    this.showCookieBanner = !cookieConsent;
  },
  mounted() {
    document.documentElement.setAttribute('lang', this.$i18n.locale);
    window.addEventListener('cookie-consent-reset', this.openCookieBanner);
  },
  beforeUnmount() {
    window.removeEventListener('cookie-consent-reset', this.openCookieBanner);
  },
  watch: {
    '$i18n.locale': function(newLocale) {
      document.documentElement.setAttribute('lang', newLocale);
      localStorage.setItem('locale', newLocale);
    },
    '$i18n.selectedLang': function(newLang) {
      localStorage.setItem('selectedLang', newLang);
    }
  }
}
</script>

<style>
.page {
  height: 100%;
  min-height: 80vh;
  margin: 80px auto;
  text-align: center;
}

.cookie-banner {
  position: fixed;
  left: 16px;
  right: 16px;
  bottom: 16px;
  z-index: 2100;
}

.cookie-banner-content {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
  padding: 14px;
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
}

.cookie-banner-content p {
  margin: 0;
  text-align: left;
  font-size: 14px;
  line-height: 1.5;
}

.cookie-policy-link {
  color: #1d4ed8;
  font-weight: 600;
  text-decoration: underline;
}

.cookie-policy-link:hover {
  color: #1e40af;
}

.cookie-banner-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

@media (max-width: 1200px) {
  .page {
    margin: 0 auto;
  }
}

@media (max-width: 700px) {
  .cookie-banner {
    left: 10px;
    right: 10px;
    bottom: 10px;
  }

  .cookie-banner-content {
    flex-direction: column;
    align-items: stretch;
  }

  .cookie-banner-actions {
    justify-content: flex-end;
  }
}
</style>
